import { Routes } from '@angular/router';
import {Users} from './users/users';
import {UserForm} from './user-form/user-form';
import { hasPermissionGuard } from '../../../guards/has-permission-guard';
import { inject } from '@angular/core';
import { firstValueFrom } from 'rxjs';
import { LayoutService } from '../../../services/layout.service';

export const usersRoutes: Routes = [
  {
    path: '',
    loadComponent: () => Users,
    title: async () => {
      const title = await firstValueFrom(inject(LayoutService).systemTitle$);
      return `${title} - Usuários`;
    }
   },
  {
    path: ':id',
    loadComponent: () => UserForm,
    title: async () => {
      const title = await firstValueFrom(inject(LayoutService).systemTitle$);
      return `${title} - Usuário`;
    }
   },
];
